import React from "react"
import { DatoContentBaseProps } from "../../types"
import HeroImageSplit from "@components/HeroImageSplit"

interface DatoCmsComponentHeroImageSplitProps extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const plainTextFromStructured = (value?: { value?: any }) => {
  const document = value?.value?.document
  if (!document) return undefined
  let result = ""
  const walk = (node: any) => {
    if (!node) return
    if (node.type === "span" && typeof node.value === "string") {
      result += node.value
      return
    }
    if (Array.isArray(node.children)) {
      node.children.forEach(walk)
      if (node.type === "paragraph") result += "\n"
    }
  }
  walk(document)
  return result.trim() || undefined
}

const DatoCmsComponentHeroImageSplit: React.FC<
  DatoCmsComponentHeroImageSplitProps
> = ({
  imageLayout,
  leftImage,
  rightImage,
  leftColor,
  rightColor,
  leftImageText,
  leftImageTextColor,
  leftImageUpperSubtitle,
  leftImageSubtitleColor,
  rightImageText,
  rightImageTextColor,
  rightImageUpperSubtitle,
  rightImageSubtitleColor,
  leftImageButtonText,
  leftImageButtonLink,
  leftImageButtonColor,
  leftImageButtonTextColor,
  rightImageButtonText,
  rightImageButtonLink,
  rightImageButtonColor,
  rightImageButtonTextColor,
}) => {
  return (
    <HeroImageSplit
      imageLayout={imageLayout}
      leftSide={{
        imageSrc: leftImage?.responsiveImage?.src || leftImage?.url,
        bgColor: stripHash(leftColor?.hex),
        text: plainTextFromStructured(leftImageText) || leftImageText,
        textColor: stripHash(leftImageTextColor?.hex),
        upperSubtitle: leftImageUpperSubtitle,
        subtitleColor: stripHash(leftImageSubtitleColor?.hex),
        buttonText: leftImageButtonText,
        buttonLink: leftImageButtonLink,
        buttonColor: stripHash(leftImageButtonColor?.hex),
        buttonTextColor: stripHash(leftImageButtonTextColor?.hex),
      }}
      rightSide={{
        imageSrc: rightImage?.responsiveImage?.src || rightImage?.url,
        bgColor: stripHash(rightColor?.hex),
        text: plainTextFromStructured(rightImageText) || rightImageText,
        textColor: stripHash(rightImageTextColor?.hex),
        upperSubtitle: rightImageUpperSubtitle,
        subtitleColor: stripHash(rightImageSubtitleColor?.hex),
        buttonText: rightImageButtonText,
        buttonLink: rightImageButtonLink,
        buttonColor: stripHash(rightImageButtonColor?.hex),
        buttonTextColor: stripHash(rightImageButtonTextColor?.hex),
      }}
    />
  )
}

export default DatoCmsComponentHeroImageSplit
